import * as Sentry from "@sentry/react";
import * as Observoo from "observoo-sdk";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (dsn) {
	Sentry.init({
		dsn,
		environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string) ?? "development",
		integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
		tracesSampleRate: 0.2,
		replaysOnErrorSampleRate: 1.0,
		replaysSessionSampleRate: 0.05,
		sendDefaultPii: false,
	});
}

const observooKey = import.meta.env.VITE_OBSERVOO_SDK_KEY as string | undefined;
if (observooKey) {
	Observoo.init({ sdkKey: observooKey });
}
